import Constants from "../../constants/constants";
import {httpGet, httpPost} from '../api/axios_api';

export async function getMasquaradeUsers(search_terms, token)
{
    let url = `${Constants.BACKEND_URL}/masquarade/users`;
    return httpGet(url,{params: {search_params: search_terms} }, token);
}

export async function masquaradeUser(user_id, token)
{
    let url = `${Constants.BACKEND_URL}/masquarade/user`;
    return httpPost(url, {user_id}, token);
}

export async function revertMasquarade(token)
{
    let url = `${Constants.BACKEND_URL}/masquarade/revert`;
    return httpGet(url, {}, token)
}


// WEBPACK FOOTER //
// ./src/modules/system/masquarade_api.js